import React from 'react';
import { FieldControlProps } from '../FieldRenderer';
import OptionButtons from './OptionButtons';

// display_style: buttons (default) | dropdown
const ChoiceInput: React.FC<FieldControlProps> = ({ field, value, onChange }) => {
  const options = field.options ?? [];

  if (field.display_style === 'dropdown') {
    // <select> values are strings; map back to the option so a numeric value stays a number.
    return (
      <select
        className="report-field-select"
        aria-label={field.field_label}
        value={value === null || value === undefined ? '' : String(value)}
        onChange={(e) => onChange(options.find((o) => String(o.value) === e.target.value)?.value ?? null)}
      >
        <option value="" disabled>
          Select…
        </option>
        {options.map((opt) => (
          <option key={String(opt.value)} value={String(opt.value)}>
            {opt.label}
          </option>
        ))}
      </select>
    );
  }

  return <OptionButtons label={field.field_label} options={options} isSelected={(v) => v === value} onPick={onChange} />;
};

export default ChoiceInput;
